(function(angular) {
	'use strict';
	/*
	 * Notification service
	 */
	var core = angular.module('Core');
	core.service('LoaderService', function($timeout) {
		var loaderShown = 0;
		var close = function() {
			if (loaderShown === 0) {
				var elt = $('#app-loader');
				if (elt) {
					//elt.hide();
					elt.removeClass('fade in');
					elt.addClass('fade out');
				}
			}
		};
		this.show = function() {
			if (loaderShown === 0) {
				setTimeout(function() {
					if (loaderShown > 0) {
						var elt = $('#app-loader');
						if (elt) {
							elt.removeClass('fade out');
							elt.addClass('fade in');
						}
					}
				}, 300);
			}
			loaderShown++;
		};
		this.hide = function() {
			loaderShown--;
			if (loaderShown < 0) {
				loaderShown = 0;
			}
			$timeout(function() {
				if (loaderShown === 0) {
					close();
					$timeout(function() {
						close();
					}, 2000);
				}
			}, 300);
		};
		close();
	});
})(angular);
